<script>
export default {
    props: ['initial'],
    data() {
        return {
            activeTab: null,
        }
    },
    mounted() {
        this.activeTab = this.initial
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab;
        }
    },
    render() {
        return this.$scopedSlots.default({
            activeTab: this.activeTab,
            changeTab: this.changeTab,
        })
    }
};
</script>
